/** CLOS-13488 — hardcoded copy until i18n/Squidex is updated later. */
export const ORDER_SUCCESS_MESSAGE =
  'Your order has been successfully submitted'

/** CLOS-13488 / CLOS-13820 — EBS hold name must match HoldType.PostTrialAccess. */
export const PTA_HOLD_COPY = {
  title: 'Your order is under Post Trial Access review',
  maMessage:
    'This order is on a Post Trial Access hold. Our PTA team will review it before processing continues. No further action is required from you.'
} as const
